module.exports = __webpack_public_path__ + "static/budget-c711ca39842b08717acf84471ae470ef.png";